//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      families: [],
      categories: [],
      products: [],
      instock: false,
      page: 1,
      loadingNew: false,
      perPage: 24,
      noMoreResults: false,
      filtering: false,
      order: 'newest',
      chooseSort: false,
    };
  },
  computed: {
    filteredProducts() {
      return this.products;
    },
    sortingName() {
      let result = '';
      switch (this.order) {
        case 'newest':
          result = 'Nejnovější';
          break;
        case 'priceup':
          result = 'Nejlevnější';
          break;
        case 'pricedown':
          result = 'Nejdražší';
          break;
      }
      return result;
    },
    sortingOptions() {
      let options = [];
      switch (this.order) {
        case 'newest':
          options = [
            {
              title: 'Nejlevnější',
              slug: 'priceup',
            },
            {
              title: 'Nejdražší',
              slug: 'pricedown',
            },
          ];
          break;
        case 'priceup':
          options = [
            {
              title: 'Nejnovější',
              slug: 'newest',
            },
            {
              title: 'Nejdražší',
              slug: 'pricedown',
            },
          ];
          break;
        case 'pricedown':
          options = [
            {
              title: 'Nejnovější',
              slug: 'newest',
            },
            {
              title: 'Nejlevnější',
              slug: 'priceup',
            },
          ];
          break;
      }
      return options;
    },
  },
  methods: {
    getArgs() {
      let args = {
        per_page: this.perPage,
        page: this.page,
        catalog_visibility: 'visible',
      };
      if (this.categories.length) {
        args.category = this.categories.join(',');
      }
      if (this.families.length) {
        args.color_family = this.families.join(',');
      }
      if (this.instock) {
        args.stock_status = 'instock';
      }
      switch (this.order) {
        case 'newest':
          break;
        case 'priceup':
          args.orderby = 'price';
          args.order = 'asc';
          break;
        case 'pricedown':
          args.orderby = 'price';
          args.order = 'desc';
          break;
      }
      return args;
    },
    filterChanged(filter) {
      this[filter.type] = filter.value;
      this.page = 1;
      const args = this.getArgs();
      this.filtering = true;
      WooCommerce.get('products', args).then(response => {
        this.products = response.data;
        this.noMoreResults = false;
        this.filtering = false;
      });
    },
    formatPrice(price) {
      const formated = parseFloat(price)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return `${formated} Kč`;
    },
    lazyloadProducts(event) {
      const element = event.target;
      const rest =
        element.scrollHeight - element.scrollTop - element.clientHeight;
      const treshold = 350;
      if (rest < treshold && !this.loadingNew && !this.noMoreResults) {
        this.loadingNew = true;
        this.page += 1;
        // Filters
        const args = this.getArgs();
        WooCommerce.get('products', args).then(response => {
          if (response.data.length) {
            this.products.push(...response.data);
          } else {
            this.noMoreResults = true;
          }
          this.loadingNew = false;
        });
      }
    },
    changeSort(sort) {
      this.order = sort;
      this.chooseSort = false;
      this.page = 1;
      let args = this.getArgs();
      this.filtering = true;
      WooCommerce.get('products', args).then(response => {
        this.products = response.data;
        this.noMoreResults = false;
        this.filtering = false;
      });
    },
  },
  mounted() {
    WooCommerce.get('products', {
      per_page: this.perPage,
      catalog_visibility: 'visible',
    }).then(response => {
      this.products = response.data;
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/catalog/App.vue